var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[(_vm.getUrl)?_c('div',{staticClass:"icon",on:{"click":_vm.back}},[_c('van-icon',{attrs:{"name":"arrow-left","color":"#fff","size":"14px"}})],1):_vm._e(),_c('div',{staticClass:"title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }